import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PersonsComponent } from './persons.component';
import { PersonsListComponent } from './persons-list/persons-list.component';
import { OrganizationHierarchyComponent } from './organizationhierarchy/organizationhierarchy.component';
import { PersonAuxDataComponent } from './personauxdata/personauxdata.component';
import { AuthService } from '../services/auth.service';
import { AuthGuard } from '../services/auth-guard.service';

const personsRoutes: Routes = [
  {
    path: 'persons', component: PersonsComponent,
    children: [
      { path: 'persons-list', component: PersonsListComponent, canActivate: [AuthGuard] },
      { path: 'organizationhierarchy', component: OrganizationHierarchyComponent, canActivate: [AuthGuard] },
      { path: 'personauxdata0', component: PersonAuxDataComponent, canActivate: [AuthGuard] },
      { path: 'personauxdata1', component: PersonAuxDataComponent, canActivate: [AuthGuard] },
      { path: 'personauxdata2', component: PersonAuxDataComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(personsRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthService, AuthGuard
  ]
})
export class PersonsRoutingModule { }
